import { uploadIsBusy } from './UploadStore';

export const updateUploadIsBusy = (value) => uploadIsBusy.update((oldValue) => value);
